// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.

export * from "./locale/af.js";
export * from "./locale/ar.js";
export * from "./locale/ar-DZ.js";
export * from "./locale/ar-EG.js";
export * from "./locale/ar-MA.js";
export * from "./locale/ar-SA.js";
export * from "./locale/ar-TN.js";
export * from "./locale/az.js";
export * from "./locale/be.js";
export * from "./locale/be-tarask.js";
export * from "./locale/bg.js";
export * from "./locale/bn.js";
export * from "./locale/bs.js";
export * from "./locale/ca.js";
export * from "./locale/ckb.js";
export * from "./locale/cs.js";
export * from "./locale/cy.js";
export * from "./locale/da.js";
export * from "./locale/de.js";
export * from "./locale/de-AT.js";
export * from "./locale/el.js";
export * from "./locale/en-AU.js";
export * from "./locale/en-CA.js";
export * from "./locale/en-GB.js";
export * from "./locale/en-IE.js";
export * from "./locale/en-IN.js";
export * from "./locale/en-NZ.js";
export * from "./locale/en-US.js";
export * from "./locale/en-ZA.js";
export * from "./locale/eo.js";
export * from "./locale/es.js";
export * from "./locale/et.js";
export * from "./locale/eu.js";
export * from "./locale/fa-IR.js";
export * from "./locale/fi.js";
export * from "./locale/fr.js";
export * from "./locale/fr-CA.js";
export * from "./locale/fr-CH.js";
export * from "./locale/fy.js";
export * from "./locale/gd.js";
export * from "./locale/gl.js";
export * from "./locale/gu.js";
export * from "./locale/he.js";
export * from "./locale/hi.js";
export * from "./locale/hr.js";
export * from "./locale/ht.js";
export * from "./locale/hu.js";
export * from "./locale/hy.js";
export * from "./locale/id.js";
export * from "./locale/is.js";
export * from "./locale/it.js";
export * from "./locale/it-CH.js";
export * from "./locale/ja.js";
export * from "./locale/ja-Hira.js";
export * from "./locale/ka.js";
export * from "./locale/kk.js";
export * from "./locale/km.js";
export * from "./locale/kn.js";
export * from "./locale/ko.js";
export * from "./locale/lb.js";
export * from "./locale/lt.js";
export * from "./locale/lv.js";
export * from "./locale/mk.js";
export * from "./locale/mn.js";
export * from "./locale/ms.js";
export * from "./locale/mt.js";
export * from "./locale/nb.js";
export * from "./locale/nl.js";
export * from "./locale/nl-BE.js";
export * from "./locale/nn.js";
export * from "./locale/oc.js";
export * from "./locale/pl.js";
export * from "./locale/pt.js";
export * from "./locale/pt-BR.js";
export * from "./locale/ro.js";
export * from "./locale/ru.js";
export * from "./locale/se.js";
export * from "./locale/sk.js";
export * from "./locale/sl.js";
export * from "./locale/sq.js";
export * from "./locale/sr.js";
export * from "./locale/sr-Latn.js";
export * from "./locale/sv.js";
export * from "./locale/ta.js";
export * from "./locale/te.js";
export * from "./locale/th.js";
export * from "./locale/tr.js";
export * from "./locale/ug.js";
export * from "./locale/uk.js";
export * from "./locale/uz.js";
export * from "./locale/uz-Cyrl.js";
export * from "./locale/vi.js";
export * from "./locale/zh-CN.js";
export * from "./locale/zh-HK.js";
export * from "./locale/zh-TW.js";
